export default "__VITE_ASSET__BcAKLa8Z__"